export default IconXboxA => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-xbox-a" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M12 21a9 9 0 0 0 9 -9a9 9 0 0 0 -9 -9a9 9 0 0 0 -9 9a9 9 0 0 0 9 9z" />
  <path d="M15 16l-3 -8l-3 8" />
  <path d="M14 14h-4" />
</svg>`;